const DIA = 86400000;
const calendarioSP = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit'
});

export const REGRA_PRAZO_SEMANAL = 'Segunda e terça: alterações desde a segunda-feira da semana anterior. De quarta a domingo: somente desde a segunda-feira da semana atual.';

// Representacao UTC apenas da data civil de Sao Paulo, sem depender do fuso do navegador.
export function diaCivilSP(valor) {
  let data = valor;
  if (typeof valor === 'string') {
    const partes = /^(\d{4})-(\d{2})-(\d{2})(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(Z|[+-]\d{2}:\d{2})?)?$/.exec(valor);
    if (!partes) return null;
    const [, ano, mes, dia, fuso] = partes;
    const instante = Date.UTC(Number(ano), Number(mes) - 1, Number(dia));
    const teste = new Date(instante);
    if (teste.getUTCFullYear() !== Number(ano) || teste.getUTCMonth() !== Number(mes) - 1 || teste.getUTCDate() !== Number(dia)) return null;
    if (!fuso) {
      // Formato de Agenda.start ou datetime-local: data e hora civis do estabelecimento.
      const hora = valor.slice(11).split(':');
      if (hora.length > 1 && (Number(hora[0]) > 23 || Number(hora[1]) > 59 || Number(hora[2] || 0) >= 60)) return null;
      return instante;
    }
    data = new Date(valor);
  }
  if (!(data instanceof Date) || !Number.isFinite(data.getTime())) return null;
  const partes = Object.fromEntries(calendarioSP.formatToParts(data).map(p => [p.type, p.value]));
  return Date.UTC(Number(partes.year), Number(partes.month) - 1, Number(partes.day));
}

export function inicioJanelaSemanal(agora = new Date()) {
  const hoje = diaCivilSP(agora);
  if (hoje === null) return null;
  const desdeSegunda = (new Date(hoje).getUTCDay() + 6) % 7;
  return hoje - (desdeSegunda + (desdeSegunda <= 1 ? 7 : 0)) * DIA;
}

export function dentroJanelaSemanal(inicio, agora = new Date()) {
  const diaAgenda = diaCivilSP(inicio);
  const minimo = inicioJanelaSemanal(agora);
  return diaAgenda !== null && minimo !== null && diaAgenda >= minimo;
}
